import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

let routes = [
	{
		path: '/',
		redirect: '/index'
	},
	{
		path: '/index',
		name: 'index',
		component: () => import(/* index */ '@/views/index.vue'),
		meta: { title: '首页' },
	},
	{
		path: '/method',
		name: 'method',
		component: () => import(/* method */ '@/views/method.vue'),
		meta: { title: '功法健体' },
	},
	{
		path: '/culture',
		name: 'culture',
		component: () => import(/* culture */ '@/views/culture.vue'),
		meta: { title: '国学文化' },
	},
	{
		path: '/aboutUs',
		name: 'aboutUs',
		component: () => import(/* aboutUs */ '@/views/aboutUs.vue'),
		meta: { title: '关于我们' },
	},
	{
		path: '/joinUs',
		name: 'joinUs',
		component: () => import(/* joinUs */ '@/views/joinUs.vue'),
		meta: { title: '加入我们' },
	},
	{
		path: '/aptitude',
		name: 'aptitude',
		component: () => import(/* aptitude */ '@/views/aptitude.vue'),
		meta: { title: '审核' },
	}
];

const router = new VueRouter({
	routes,
});

export default router;
